const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/setup/routerHistory.ts';
import { createHashHistory } from 'history';
import { createReduxHistoryContext } from 'redux-first-history';

export const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
    history: createHashHistory({
        getUserConfirmation(_message: any, callback: any) {
            callback(false);
        },
    }),
});
